import React, { useMemo, useRef, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { CheckIcon, CopyIcon, DownloadIcon, ExternalLinkIcon, QrCodeIcon } from 'lucide-react';
import { Button } from '../ui/Button';
interface QrCodeCardProps {
  source: string;
  previewUrl: string;
}
export function QrCodeCard({
  source,
  previewUrl
}: QrCodeCardProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [copied, setCopied] = useState(false);
  const url = useMemo(() => `${window.location.origin}/backstage?source=${encodeURIComponent(source)}`, [source]);
  const copyLink = async () => {
    await navigator.clipboard?.writeText(url);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  };
  const downloadQr = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const png = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = png;
    link.download = `coopers-backstage-${source}.png`;
    link.click();
  };
  return <div className="overflow-hidden rounded-3xl border border-[#d98b52]/20 bg-[#1d1512] shadow-[0_24px_60px_-24px_rgba(0,0,0,0.8)]" data-id="element-415" data-mp="3589rc9ulr7tq">
      <div className="border-b border-white/[0.07] px-5 py-4" data-id="element-416" data-mp="3eaiwslb0kb09">
        <div className="flex items-center gap-2 text-[13px] font-semibold text-white" data-id="element-417" data-mp="3e9zhzdgnu2qg">
          <QrCodeIcon className="h-4 w-4 text-[#e8a369]" data-id="element-418" data-mp="3aa8qf7jb7ikv" /> Campaign QR code
        </div>
        <p className="mt-1 text-[12px] text-zinc-500" data-id="element-419" data-mp="2mkeeqtaq8027">Every scan is attributed to this campaign.</p>
      </div>
      <div className="flex flex-col items-center px-6 py-6" data-id="element-420" data-mp="2hltggzf1bqge">
        <div className="rounded-2xl bg-[#fff8ef] p-3 shadow-[0_10px_30px_rgba(0,0,0,0.25)]" data-id="element-421" data-mp="2vc6of1rxf55q">
          <QRCodeCanvas ref={canvasRef} value={url} size={184} level="H" includeMargin bgColor="#fff8ef" fgColor="#1d1512" data-id="element-422" data-mp="2ql6ororfa8zj" />
        </div>
        <p className="mt-4 max-w-[260px] text-center text-[12px] leading-relaxed text-zinc-400" data-id="element-423" data-mp="1yszauw3axaou">
          Fans scan to unlock Cooper’s Backstage and join your list.
        </p>
      </div>
      <div className="grid grid-cols-2 gap-2 border-t border-white/[0.07] p-3" data-id="element-424" data-mp="6r618zstqbcg">
        <Button variant="primary" size="sm" onClick={downloadQr} className="bg-[#d97742] hover:bg-[#e08d59] shadow-none" data-id="element-425" data-mp="biecm1dps6s9">
          <DownloadIcon className="h-3.5 w-3.5" data-id="element-426" data-mp="ggzd81wvosh8" /> Download PNG
        </Button>
        <Button variant="secondary" size="sm" onClick={copyLink} data-id="element-427" data-mp="3f0683pr278v7">
          {copied ? <CheckIcon className="h-3.5 w-3.5 text-grow" data-id="element-428" data-mp="3jyrcm1dcgepg" /> : <CopyIcon className="h-3.5 w-3.5" data-id="element-429" data-mp="3jzixoi9beu1h" />}
          {copied ? 'Copied' : 'Copy link'}
        </Button>
      </div>
      <a href={previewUrl} target="_blank" rel="noreferrer" className="flex items-center justify-center gap-1.5 border-t border-white/[0.07] py-3 text-[12px] font-medium text-[#e8a369] transition-colors hover:text-[#ffd0a4]" data-id="element-430" data-mp="3owj3qt65zwsl">
        Preview fan experience <ExternalLinkIcon className="h-3.5 w-3.5" data-id="element-431" data-mp="1954zwu7hsrjp" />
      </a>
    </div>;
}